import { useState, useCallback } from "react";
import withDocumentTitle from "../withDocumentTitle";

import PendingReturnRequestTable from "./PendingReturnRequestTable";
import HistoryReturnRequestTable from "./HistoryReturnRequestTable";

function ReturnRequestHandler() {
  const [showHistory, setShowHistory] = useState(false);

  const handleShowHistory = useCallback(() => {
    setShowHistory((prev) => !prev);
  }, []);

  return (
    <div className="tw-mt-6">
      {showHistory ? (
        <HistoryReturnRequestTable
          showHistory={showHistory}
          onShowHistory={handleShowHistory}
        />
      ) : (
        <PendingReturnRequestTable
          showHistory={showHistory}
          onShowHistory={handleShowHistory}
        />
      )}
    </div>
  );
}

export default withDocumentTitle(ReturnRequestHandler, {
  pageTitle: "Return Requests",
});
